<template lang="pug">
section
  s-page-title(:previous='true' :title='id ? "Редактирование" : "Добавление"')
  v-card
    v-container(grid-list-xl fluid)
      v-layout(wrap)
        v-flex(xs12)
          s-publish-date-status(
            :errors='errors'
            :model='model'
          )
        v-flex(xs4)
          v-text-field(
            :error='errors.has("name")'
            :error-messages='errors.first("name")'
            v-model='model.name'
            label='Название камеры'
          )
        v-flex(xs4)
          v-text-field(
            :error='errors.has("cam_code")'
            :error-messages='errors.first("cam_code")'
            :rules='[v => !v || v && v.length <= 20 || "Макс. длина 20 символов"]'
            v-model='model.cam_code'
            label='Код камеры'
          )
        v-flex(xs4)
          s-complex-picker(
            @change='flushObjectIds'
            :error='errors.has("complex_id")'
            :error-messages='errors.first("complex_id")'
            label='Комплекс'
            v-model='model.complex_id'
          )
        v-flex(xs12)
          s-object-picker(
            :error='errors.has("object_ids")'
            :error-messages='errors.first("object_ids")'
            :filter='x => x.complex_id == model.complex_id'
            label='Выберите объект'
            v-model='model.object_ids'
            clearable
            multiple
            chips
          )
        v-flex(xs3)
          v-text-field(
            :error='errors.has("linia_number")'
            :error-messages='errors.first("linia_number")'
            :rules='[v => $rules.number(v) || "Введите число"]'
            v-model='model.linia_number'
            label='Номер в линии'
          )
        v-flex(xs3)
          v-text-field(
            :error='errors.has("default_width")'
            :error-messages='errors.first("default_width")'
            :rules='[v => $rules.number(v) || "Введите число"]'
            v-model='model.default_width'
            label='Ширина, px'
          )
        v-flex(xs3)
          v-text-field(
            :error='errors.has("default_height")'
            :error-messages='errors.first("default_height")'
            :rules='[v => $rules.number(v) || "Введите число"]'
            v-model='model.default_height'
            label='Высота, px'
          )
        v-flex(xs3)
          v-text-field(
            :error='errors.has("default_rate")'
            :error-messages='errors.first("default_rate")'
            :rules='[v => $rules.number(v) || "Введите число"]'
            v-model='model.default_rate'
            label='Кадров/сек'
          )
        v-flex(xs12)
          v-textarea(
            :error='errors.has("comment")'
            :error-messages='errors.first("comment")'
            v-model='model.comment'
            label='Комментарий'
          )
        v-flex(xs6)
          v-flex(xs12)
            div(class='mb-3')
              v-label Последний скриншот камеры
            v-img(
              :lazy-src='model.last_screenshot'
              :src='model.last_screenshot'
              class='grey lighten-4'
              contain
            )
              v-layout(slot='placeholder')
                v-progress-circular(indeterminate color='primary')
          v-flex(xs12)
            v-checkbox(
              v-model='model.is_timelapsed'
              label='Снимать скриншоты с камеры'
              color='primary'
            )
        v-flex(xs6)
          v-flex(v-if='model.camera_mjpeg && !hls' xs12)
            div(class='mb-3')
              v-label Поток MJPEG
            v-img(
              :lazy-src='model.camera_mjpeg'
              :src='model.camera_mjpeg'
              class='grey lighten-4'
              contain
            )
              v-layout(slot='placeholder')
                v-progress-circular(indeterminate color='primary')
          v-flex(v-if='model.camera_stream && hls' xs12)
            div(class='mb-3')
              v-label Поток HLS
            videojs(:poster='model.last_screenshot' :stream='model.camera_stream')
          v-flex(xs12)
            v-checkbox(
              v-model='hls'
              label='Видеопоток камеры (HLS)'
              color='primary'
            )
    v-card-actions(class='large')
      v-spacer
      s-back-btn
      v-btn(
        @click='onSave'
        :loading='isLoading'
        color='primary'
        depressed
      ) Сохранить
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  props: ['id'],

  components: {
    Videojs: () => import('@/components/async/Videojs')
  },

  data: () => ({
    model: {},
    hls: false
  }),

  async created() {
    if (!this.id) return
    this.updateItem()
  },

  methods: {
    async updateItem() {
      this.model = (await this.fetchSingle({ id: this.id })).data
    },

    async onSave() {
      try {
        if (this.id) {
          await this.update({
            id: this.id,
            data: this.model
          })
        } else {
          await this.create({
            data: this.model
          })
        }

        this.$root.showSnack('Сохранено')
        this.$router.push({ name: 'Admin.Cameras.List' })
      } catch (e) {
        this.$showServerErrors(e)
      }
    },

    flushObjectIds() {
      this.model.object_ids = []
    },

    ...mapActions('admin/cameras', ['fetchSingle', 'update', 'create'])
  },

  computed: {
    ...mapGetters('admin/cameras', ['isLoading'])
  }
}
</script>
